// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"doctor_wrapper__3qceD","toolbar":"doctor_toolbar__3nou7","tableWrapper":"doctor_tableWrapper__20tWl"};